import { AppConfig } from "./config";

export const localConfig: AppConfig = {
  graphqlUri: "http://localhost:5000",
};
